// extracted by mini-css-extract-plugin
module.exports = {"section":"HeroSection_section__7x8wV","textSection":"HeroSection_textSection__1_mTC","pictureSection":"HeroSection_pictureSection__iFu7T"};